import { render, staticRenderFns } from "./quotation_details.vue?vue&type=template&id=872c770a&scoped=true&"
import script from "./quotation_details.vue?vue&type=script&lang=js&"
export * from "./quotation_details.vue?vue&type=script&lang=js&"
import style0 from "./quotation_details.vue?vue&type=style&index=0&id=872c770a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c770a",
  null
  
)

export default component.exports